import {Provider} from '@oilstone/container';
import Client from '@oilstone/http-client';

export default new Provider().register(container => {
    container.singleton('httpClient', () => {
        return Client.make();
    });
});